module.exports = __webpack_public_path__ + "static/media/ipad_10_9_inch_air_starlight.e9f9d411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_10_9_inch_air_starlight.png
// module id = 2109
// module chunks = 0